





import Selector from 'vux/src/components/selector/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import CellBox from 'vux/src/components/cell-box/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import PopupRadio from 'vux/src/components/popup-radio/index.vue'
import PopupPicker from 'vux/src/components/popup-picker/index.vue'
import Toast from 'vux/src/components/toast/index.vue'
import Popup from 'vux/src/components/popup/index.vue'
import XProgress from 'vux/src/components/x-progress/index.vue'

import OnInput from "../oneInput/oneInput.vue";
import TwoInput from "../twoInput/twoInput.vue";
import TheryInput from "../theryInput/theryInput.vue";
import { modelView,cardView } from '../../api/api';
import { uploadQiniu, uploadQiniuSetKey } from "../../qiniu/index";
import { trimSpace } from "../../utils/encapsulationMethod";
import { getVuxUrlQuery, createRequest, getUrlParams } from "../../utils/utils";
import { STORAGE_KEY } from '../../utils/define';
import MyVideo from '../myVideo/myVideo.vue';

export default {
uploadingHandler: undefined,
name: "chatframe",
components: {
Group,
Selector,
Cell,
CellBox,
XButton,
XInput,
OnInput,
TwoInput,
TheryInput,
PopupRadio,
PopupPicker,
Toast,
Popup,
XProgress,
MyVideo,
},
props: {
delValueIs: String,
movementList: Array,
spareName:String,
typeIs:Number,
modelID:Number,
cardTypeIs:String
},
data() {
return {
value2: "",
inputList: [""],
showPositionValue: false,
position: "default",
oneInputValue: "", //第一个input子集传值
twoInputValue: "", //第2个input子集传值
threeInputValue: "", //第3个input子集传值
imageUrl: "",
imageKey: "",
list: [],
issueValue: "",
pdfNmae: "",
videoUrl: "",
videoCover:"",
showVideo: false,
setPreinstallState: false,
gender: 0,
activeSpareName:this.spareName,
uploadProgress:0
};
},
mounted() {
this.getMovement();
this.activeSpareName = localStorage.getItem(STORAGE_KEY.MODEL_NAME)

console.log('%c⧭', 'color: #ffa280', localStorage.getItem(STORAGE_KEY.MODEL_NAME))
console.log("activeSpareName",this.activeSpareName)
},
beforeDestroy() {},
methods: {

onSetPreinstall() {
this.setPreinstallState = !this.setPreinstallState;
},

getMovement() {
if(this.cardTypeIs == '3d')
{
createRequest(
"get",
"applet/webview/model_view",
{ image_id: localStorage.getItem(STORAGE_KEY.MODEL_ID) },
(res) => {
console.log("%c⧭", "color: #bfffc8", res);
if (res.code == 200) {
this.gender = res.data.image.gender;
createRequest(
"get",
"applet/webview/config",
{ version: res.data.image.version },
(reg) => {
console.log("%c⧭", "color: #bfffc8", res);
if (reg.code == 200) {
let list = reg.data.action_map[String(this.gender)];
let data = [];
list.forEach((item) => {
let obj = {
value: ` ${item.name}`,
key: item.id,
pic: item.pic,
video: item.video,
gender: item.gender,
};
data.push(obj);
});
this.list = data;
console.log(this.movementList);
} else {
console.error(reg.msg);
this.$vux.toast.show({
type: "text",
text: reg.msg,
});
}
}
);
} else {
console.error(res.msg);
this.$vux.toast.show({
type: "text",
text: res.msg,
});
}
}
);
}
else if(this.cardTypeIs == '2d')
{
let id = localStorage.getItem(STORAGE_KEY.MODEL_ID)
cardView(id).then((res) => {
if (res.code == 200) {
this.gender = res.data.card.gender;
createRequest(
"get",
"applet/webview/config",
{version: res.data.card.version},
(reg) => {
console.log("%c⧭", "color: #bfffc8", res);
if (reg.code == 200) {
let list = reg.data.action_map[String(this.gender)];
let data = [];
list.forEach((item) => {
let obj = {
value: ` ${item.name}`,
key: item.id,
pic: item.pic,
video: item.video,
gender: item.gender,
};
data.push(obj);
});
this.list = data;
console.log(this.movementList);
} else {
console.error(reg.msg);
this.$vux.toast.show({
type: "text",
text: reg.msg,
});
}
}
);
} else {
console.error(res.msg);
this.$vux.toast.show({
type: "text",
text: res.msg,
});
}
console.log('%c⧭', 'color: #40fff2', res)
});
}

},

onLookVideo() {
this.showVideo = true;
},


onSave() {
if(this.value2 == '')
{
this.$vux.toast.show({
type: "text",
text: '请选择动作',
});
return;
}
if(this.issueValue == '')
{
this.$vux.toast.show({
type: "text",
text: '请输入问题',
});
return;
}
if (this.inputList.length == 1) {
this.inputList[0] = this.oneInputValue;
} else if (this.inputList.length == 2) {
this.inputList[0] = this.oneInputValue;
this.inputList[1] = this.twoInputValue;
} else if (this.inputList.length == 3) {
this.inputList[0] = this.oneInputValue;
this.inputList[1] = this.twoInputValue;
this.inputList[2] = this.threeInputValue;
}
if(this.oneInputValue <= 0)
{
this.$vux.toast.show({
type: "text",
text: '请输入回复',
});
return;
}

console.log('%c⧭', 'color: #364cd9', localStorage.getItem(STORAGE_KEY.MODEL_ID))
let replyList = trimSpace(this.inputList);
createRequest(
"post",
"applet/webview/qa/add",
{
image_id:this.cardTypeIs == '3d' ? localStorage.getItem(STORAGE_KEY.MODEL_ID) : '',
card_id:this.cardTypeIs == '2d' ? localStorage.getItem(STORAGE_KEY.MODEL_ID) : '',
action_id: this.value2,
question: this.issueValue,
answer: replyList,
file: this.imageKey,
is_presets: this.setPreinstallState ? 1 : 2,
},
(res) => {
console.log("%c⧭", "color: #d90000", res);
if (res.code == 200) {
this.$vux.toast.show({
type: "text",
text: "保存成功",
});
this.$emit("onAddSaveRouter", "costume",this.typeIs);
} else {
console.error(res.msg);
this.$vux.toast.show({
type: "text",
text: res.msg,
});
}
}
);
},

getFile(event) {
console.log('get file event',event)
let _this = this;
let file = event.target.files[0];
const chars = event.target.files[0].name.split(".");
console.log("%c⧭", "color: #f200e2");
let name = chars[chars.length - 1];
if (["pdf", "png", "jpg", "mp4"].indexOf(name.toLowerCase()) < 0) {
return this.$vux.toast.show({
type: "text",
text: "不支持的文件格式",
});
}
let fileName=event.target.files[0].name.substr(event.target.files[0].name.lastIndexOf('/')+1)
let self= this
uploadQiniuSetKey(
file,
fileName,
(res) => {
console.log("%c⧭", "color: #00e600", res);
this.uploadProgress = res.percent;
},
(err, res) => {
this.uploadProgress = 0;
if (err) {
return this.$vux.toast.show({
type: "text",
text: "上传失败:"+err,
});
}
name = name.toLowerCase()
if (name == "pdf") {
let leng = event.target.files[0].name;
let sp = leng.split('.');

console.log('%c⧭', 'color: #006dcc', sp[0].length)
if(sp[0].length < 6)
{
_this.pdfNmae = event.target.files[0].name;
}
else
{

let ont = sp[0].slice(0,6)
_this.pdfNmae =ont + '.' + sp[sp.length-1];
}
} else if (name == "png" || name == "jpg") {
_this.imageUrl = res.domain + res.key;
} else if (name == "mp4") {
_this.videoUrl = res.domain + res.key;
_this.videoCover = res.domain + res.key+'?vframe/jpg/offset/2/w/480';
}
_this.imageKey = res.key;

console.log("%c⧭", "color: #aa00ff", _this.imageUrl);
console.log("%c⧭", "color: #00a3cc", reg, res);
}
).then((currentUploadHandler) => {
this.uploadingHandler = currentUploadHandler;
});;
console.log("%c⧭", "color: #ff0000");
},

onDelImageUrlKey() {
this.imageKey = "";
this.imageUrl = "";
this.videoUrl="";
this.pdfNmae = "";
},

onAddInput() {
this.inputList.push("");
},

onDelOneInput(event) {
if (this.inputList.length == 1) {
this.showPositionValue = true;
} else if (event == 0) {
this.inputList.splice(event, 1);
this.oneInputValue = this.twoInputValue; 

console.log(
"%c⧭",
"color: #cc0036",
this.oneInputValue,
this.twoInputValue
);
this.twoInputValue = this.threeInputValue; 
this.threeInputValue = "";
}
},

onInput(event) {
this.oneInputValue = event;
console.log("%c⧭", "color: #ff6600", event);
},

onDelTwoInput(event) {
if (this.inputList.length == 1) {
this.showPositionValue = true;
} else if (event == 1) {
this.inputList.splice(event, 1);
this.twoInputValue = this.threeInputValue; 
this.threeInputValue = "";
}
},

onTwoInput(event) {
this.twoInputValue = event;

console.log("%c⧭", "color: #ff6600", event);
},

onDelThrryInput(event) {
if (this.inputList.length == 1) {
this.showPositionValue = true;
} else if (event == 2) {
this.inputList.splice(event, 1);
this.threeInputValue = "";
}
},

onTheryInput(event) {
this.threeInputValue = event;
console.log("%c⧭", "color: #ff6600", event);
},
onCancel(){
console.log('----QA back')
this.$emit('onBack','',this.typeIs)
},
onClone(){
console.log('----QA back')
this.$emit('onBackClone','',this.typeIs)
},
cancelUpload(){
console.log("cancel upload");
this.uploadingHandler && this.uploadingHandler.unsubscribe();
this.uploadProgress = 0;
}
},
watch: {
value2(value) {
this.value2 = value;

},
issueValue(value) {
this.issueValue = value;

console.log('%c⧭', 'color: #cc0088', value.length)
},
modelID(value)
{
this.activeSpareName = localStorage.getItem(STORAGE_KEY.MODEL_NAME)
}
},
};



// WEBPACK FOOTER //
// ./src/myComponents/AddQa/AddQa.vue